import React, { useEffect } from "react";
import { setAxiosGlobalErrorHandler } from "./axiosClient.ts";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router-dom";
import Home from "./routes/WorkoutLogsFlow/home.tsx";
import RootLayout from "./layouts/RootLayout.js";
import ErrorPage from "./error-page.tsx";
import Login from "./routes/PublicPagesFlow/login.tsx";
import Exercise from "./routes/WorkoutLogsFlow/exercise.tsx";
import Div100vh from "react-div-100vh";
import AdminDashboard from "./routes/AccountFlow/admin-dashboard.tsx";
import AdminFlowLayout from "./routes/AccountFlow/AdminFlowLayout.tsx";
import InviteUser from "./routes/AccountFlow/invite-user.tsx";
import CustomEndpoint from "./routes/AccountFlow/custom-endpoint.tsx";
import UserMetrics from "./routes/AccountFlow/user-metrics.tsx";
import DeleteUser from "./routes/AccountFlow/delete-user.tsx";
import SignUp from "./routes/PublicPagesFlow/sign-up.tsx";
import ForgotPassword from "./routes/PublicPagesFlow/forgot-password.tsx";
import AppScreensLayout from "./layouts/AppScreensLayout.js";
import Progression from "./routes/ProgressionFlow/progression.jsx";
import WorkoutTemplates from "./routes/TemplatesFlow/workout-templates.tsx";
import Account from "./routes/AccountFlow/account.tsx";
import ChangeEmail from "./routes/AccountFlow/change-email.tsx";
import ChangePassword from "./routes/AccountFlow/change-password.tsx";
import WorkoutTemplate from "./routes/TemplatesFlow/workout-template.tsx";
import ExerciseTemplate from "./routes/TemplatesFlow/exercise-template.tsx";
import ExerciseProgression from "./routes/ProgressionFlow/exercise-progression.tsx";
import ProgramsPage from "./routes/TemplatesFlow/ProgramsPage.tsx";
import WorkoutDetailsPage from "./routes/WorkoutLogsFlow/WorkoutDetailsPage.tsx";
import { ErrorProvider, useError } from "./store/ErrorContext.tsx";
import { UserRoleProvider } from "./store/UserRoleContext.tsx";
import GlobalReactErrorBoundary from "./components/FullPageError/GlobalReactErrorBoundary.tsx";
import ResetPassword from "./routes/PublicPagesFlow/reset-password.tsx";
import AuthAction from "./routes/PublicPagesFlow/auth-action.tsx";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />} errorElement={<ErrorPage />}>
      <Route path="login" element={<Login />} />
      <Route path="sign-up" element={<SignUp />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/action" element={<AuthAction />} />
      <Route element={<AppScreensLayout />}>
        <Route index element={<Home />} />
        <Route path="workout/:workoutId" element={<WorkoutDetailsPage />} />
        <Route
          path="workout/:workoutId/exercise/:exerciseId"
          element={<Exercise />}
        />

        <Route path="/progress" element={<Progression />} />
        <Route path="/progress/exercise" element={<ExerciseProgression />} />

        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/programs/:programId/" element={<WorkoutTemplates />} />
        <Route
          path="/programs/:programId/workout-templates/:workoutTemplateId"
          element={<WorkoutTemplate />}
        />
        <Route
          path="/programs/:programId/workout-templates/:workoutTemplateId/exercise-templates/:exerciseTemplateId"
          element={<ExerciseTemplate />}
        />

        <Route path="/account" element={<Account />} />
        <Route path="/account/change-email" element={<ChangeEmail />} />
        <Route
          path="/account/change-password"
          element={<ChangePassword />}
        />

        <Route path="admin-dashboard" element={<AdminFlowLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="user-metrics" element={<UserMetrics />} />
          <Route path="invite-user" element={<InviteUser />} />
          <Route path="custom-endpoint" element={<CustomEndpoint />} />
          <Route path="delete-user" element={<DeleteUser />} />
        </Route>
      </Route>

      {/* General 404 page */}
      {/* <Route path="*" element={<ErrorPage />} /> */}
    </Route>,
  ),
);

const AppWithErrorHandler = () => {
  const { setError } = useError();

  useEffect(() => {
    setAxiosGlobalErrorHandler(setError);
  }, [setError]);

  return (
    <Div100vh>
      <UserRoleProvider>
        <RouterProvider router={router} />
      </UserRoleProvider>
    </Div100vh>
  );
};

function App() {
  return (
    <ErrorProvider>
      <GlobalReactErrorBoundary>
        <AppWithErrorHandler />
      </GlobalReactErrorBoundary>
    </ErrorProvider>
  );
}

export default App;
